import {
  REMOVE_USER,
  INSERT_USER,
  LOAD_PROCESSED_USERS,
  INSERT_USER_STATUSES,
  INSERT_CHECKIN_MODES,
  INSERT_PANIC_BUTTONS,
  DELETE_ASSOCIATED_USER_PANIC_BUTTON,
  INSERT_ASSOCIATED_USER_PANIC_BUTTON,
  SET_LAST_USERS_CHECKED,
} from '../actions/userActions';
import {
  INSERT_USER_PREFERENCES,
  INSERT_CATEGORY_DISPLAY_ITEMS,
  APPEND_CATEGORY_DISPLAY_ITEMS,
  INSERT_CATEGORY_DISPLAY_ITEM,
  DELETE_CATEGORY_DISPLAY_ITEM,
  INSERT_ALERT_GROUP_PERMISSIONS,
  INSERT_ADDED_ALERT_GROUP_PERMISSIONS,
  DELETE_REMOVED_ALERT_GROUP_PERMISSIONS,
} from '../actions/userStaffPreferencesActions';
import { INSERT_USER_CHECKIN_PROFILE } from '../actions/userCheckinProfileActions';

/**
 * Reducers for users
 * @param {object} state
 * @param {object} action
 */
function users(
  state = {
    users: {},
    userStatuses: {},
    lastChecked: '',
    checkinModes: {},
    categoryDisplay: {},
    alertGroupPermissions: {},
    panicButtons: {},
  },
  action
) {
  switch (action.type) {
    case INSERT_USER:
      let userObj = {};
      if (state.users[action.payload.id]) {
        userObj = state.users[action.payload.id];
      }
      return {
        ...state,
        users: {
          ...state.users,
          [action.payload.id]: {
            ...userObj,
            ...action.payload,
          },
        },
      };

    case REMOVE_USER:
      const updatedState = state.users;
      const userToRemove = action.payload.id;
      delete updatedState[userToRemove];

      return {
        ...state,

        users: updatedState,
      };

    case SET_LAST_USERS_CHECKED:
      // update the date/time when the api was last checked for users updates
      return {
        ...state,
        lastChecked: action.payload,
      };
    case LOAD_PROCESSED_USERS:
      // This is for the initial loading of users and just takes in all of them and replaces the current users object with the updated users
      return {
        ...state,

        users: action.payload,
      };
    case INSERT_USER_STATUSES:
      // This is for the initial loading of user statuses and just takes in all of them and replaces the current object with the updated data
      return {
        ...state,

        userStatuses: action.payload,
      };

    case INSERT_CHECKIN_MODES:
      // This is for the initial loading of checkin modes and just takes in all of them and replaces the current object with the updated data
      return {
        ...state,

        checkinModes: action.payload,
      };

    case INSERT_PANIC_BUTTONS:
      // This is for the initial loading of user panic buttons and just takes in all of them and replaces the current object with the updated data
      return {
        ...state,

        panicButtons: action.payload,
      };
    case INSERT_CATEGORY_DISPLAY_ITEMS:
      // This is for the initial loading of user categories and just takes in all of them and replaces the current object with the updated data
      return {
        ...state,

        categoryDisplay: action.payload,
      };
    case APPEND_CATEGORY_DISPLAY_ITEMS:
      // This appends additional pages of category display items to the existing data
      return {
        ...state,
        categoryDisplay: {
          ...state.categoryDisplay,
          ...action.payload,
        },
      };

    case INSERT_USER_PREFERENCES: {
      // takes in a user preferences object
      // finds the user in the users object
      const userObj = state.users[action.payload.user];
      // spread the users, then spread the selected user, then insert or replace the preferences with the data from the api
      return {
        ...state,
        users: {
          ...state.users,
          [action.payload.user]: {
            ...userObj,
            preferences: action.payload,
          },
        },
      };
    }
    case INSERT_USER_CHECKIN_PROFILE: {
      // takes in a user checkin profile object
      // finds the user in the users object
      const user = state.users[action.payload.user];
      // spread the users, then spread the selected user, then insert or replace the checking profile with the data from the api
      return {
        ...state,
        users: {
          ...state.users,
          [action.payload.user]: {
            ...user,
            checkin_profile: action.payload,
          },
        },
      };
    }

    case INSERT_ASSOCIATED_USER_PANIC_BUTTON: {
      // this takes in the button information and adds it to the user object that the button is associated with
      let newButton = Object.values(action.payload.button);
      // get the current array of buttons from the user object and add the new button into the array
      const newButtons = [
        ...state.users[action.payload.id].userbuttons,
        ...newButton,
      ];
      // spread the users, then spread the selected user, then replace the userbuttons with the new array contents
      return {
        ...state,
        users: {
          ...state.users,
          [action.payload.id]: {
            ...state.users[action.payload.id],
            userbuttons: [...newButtons],
          },
        },
      };
    }

    case DELETE_ASSOCIATED_USER_PANIC_BUTTON: {
      const user = state.users[action.payload.userId];
      // get the user buttons from the selected user
      // filter through the buttons and filter out any button that has the id that matches the button to be removed
      const updatedButtons = user.userbuttons.filter(
        (b) => b.id !== action.payload.button
      );
      // spread the users, then spread the selected user, then replace the userbuttons with the new array contents
      return {
        ...state,
        users: {
          ...state.users,
          [user.id]: {
            ...user,
            userbuttons: [...updatedButtons],
          },
        },
      };
    }

    case INSERT_CATEGORY_DISPLAY_ITEM: {
      // this adds to the list of category display items
      // spread the current cateogory display object
      // insert the item into the object
      return {
        ...state,
        categoryDisplay: {
          ...state.categoryDisplay,
          [action.payload.id]: { ...action.payload },
        },
      };
      //
    }
    case DELETE_CATEGORY_DISPLAY_ITEM: {
      // this removes a category display item
      // first duplicate the current object by spreading the current contents into a new object
      const updatedCategories = { ...state.categoryDisplay };
      // delete the key and value from the  new object
      delete updatedCategories[action.payload];
      // insert the contents of the new object back into state
      return {
        ...state,

        categoryDisplay: {
          ...updatedCategories,
        },
      };
    }
    case INSERT_ALERT_GROUP_PERMISSIONS:
      // This is for the initial loading of user statuses and just takes in all of them and replaces the current users object with the updated users
      return {
        ...state,

        alertGroupPermissions: action.payload,
      };
    case INSERT_ADDED_ALERT_GROUP_PERMISSIONS:
      // This is for the initial loading of user statuses and just takes in all of them and replaces the current users object with the updated users
      return {
        ...state,

        alertGroupPermissions: {
          ...state.alertGroupPermissions,
          [action.payload.id]: { ...action.payload },
        },
      };
    // removes alert group permissions from the store
    case DELETE_REMOVED_ALERT_GROUP_PERMISSIONS:
      const updatedGroupPermissions = { ...state.alertGroupPermissions };
      delete updatedGroupPermissions[action.payload.id];
      return {
        ...state,

        alertGroupPermissions: {
          ...updatedGroupPermissions,
        },
      };
    default:
      return state;
  }
}

export default users;
